import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full mb-2"
}
const _hoisted_2 = { class: "relative flex items-center w-full h-[22px] max-h-[22px] bg-[#f3f0e9] rounded-full p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_3 = ["onClick"]

import {computed, inject, ref, watch} from "vue";
import {useStore} from "vuex";
import {ParametersVariations} from "@/assets/ts/parametersVariations";

const variantIdx = ""

const minVariantsToShow = 2


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesFormAngle',
  props: {
    groupIdx: {},
    prioSettings: { default: () => [] }
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * session
 *
 * Transferred from itemV3StonesSetting.vue: configureAll/itemIdx are wired into
 * ParametersVariations the same way, the variant is fetched per stone group via
 * getItemVariants(itemIdx, "stones.<groupIdx>.stone_form_angle") instead of a fixed idx.
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

/**
 * stone form angle - stones.<groupIdx>.stone_form_angle
 */

const stoneFormAngle = ref({
  "stone_form_angle": {}
} as any)

const getStoneFormAngleData = (groupIdy: number) => {
  if (groupIdy >= 0) {
    stoneFormAngle.value.stone_form_angle = parametersVariations.getItemVariants(itemIdx.value, "stones." + groupIdy + ".stone_form_angle")
  }
}

watch(() => props.groupIdx, (groupIdy) => {
  getStoneFormAngleData(groupIdy)
}, {immediate: true})

watch(session, () => {
  getStoneFormAngleData(props.groupIdx)
}, {deep: true})

/**
 * form angle variants
 */

const active = computed(() => stoneFormAngle.value.stone_form_angle[0])

/*
 * focus values (transferred from itemV3StonesSetting.vue)
 * - empty list: show all values
 * - otherwise: only show values whose idx is part of the list
 */

const focusValueIdx = computed(() => (props.prioSettings || []).map((idx) => parseInt(idx.toString())))

const variantsList = computed(() => {
  const values = active.value?.values || []
  if (focusValueIdx.value.length === 0) return values
  return values.filter((v: { idx: number }) => focusValueIdx.value.indexOf(v.idx) !== -1)
})

// minimum amount of values the variant list needs before
// the component is shown - until then the whole component stays invisible (v-if = false)
const activeIndex = computed(() => variantsList.value.findIndex((v: any) => v.match))

const variantsLoaded = computed(() => !!active.value && variantsList.value.length >= minVariantsToShow)

const sliderStyle = computed(() => {
  const count = variantsList.value.length;
  const activeIdx = activeIndex.value;
  if (count === 0 || activeIdx < 0 || activeIdx >= count) return {display: 'none'};

  const width = 100 / count;
  const left = activeIdx * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
});

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};


return (_ctx: any,_cache: any) => {
  return (variantsLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-full transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
            style: _normalizeStyle(sliderStyle.value)
          }, null, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsList.value, (variantData, variantIdx) => {
            return (_openBlock(), _createElementBlock("button", {
              key: variantIdx,
              type: "button",
              class: _normalizeClass(["text-[10px] tracking-wide relative flex-1 flex cursor-pointer items-center justify-center text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", variantData.match ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
              onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
            }, _toDisplayString(variantData.title) + "° ", 11, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})